export class OptionQuestion {
    id: string;
    key: string;
    value: string;
    score: number;
    comment: string;
}
